// خارج از Digi تعریف کن 👇
import { useState } from "react";
import { FaAngleRight, FaAngleDown } from "react-icons/fa";
const Collapse = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="features-card p-3">
      <div
        className="d-flex justify-content-between align-items-center"
        onClick={() => setOpen((s) => !s)}
        style={{ cursor: "pointer" }}
      >
        <div>{title}</div>
        <div>{open ? <FaAngleDown/> : <FaAngleRight/>}</div>
      </div>
      {open && <div style={{ marginTop: 12 }}>{children}</div>}
    </div>
  );
};

export default Collapse;
